export default __webpack_public_path__ + "static/media/snd_00030.b84a8df0.mp4";